import React, { useState } from "react";
import styled from "styled-components";
import { useSearchParams , useLocation, useNavigate} from "react-router-dom";
import API from "../../util/api";
import { fetchFreshPixelToken } from "../../util/pixelToken";

const EyeIcon = (props) => (
  <svg
    viewBox="0 0 576 512"
    width="1em"
    height="1em"
    fill="currentColor"
    aria-hidden="true"
    focusable="false"
    {...props}
  >
    <path d="M572.52 241.4C518.29 135.59 410.93 64 288 64S57.68 135.64 3.48 241.41a32.35 32.35 0 0 0 0 29.19C57.71 376.41 165.07 448 288 448s230.32-71.64 284.52-177.41a32.35 32.35 0 0 0 0-29.19zM288 400a144 144 0 1 1 144-144 143.93 143.93 0 0 1-144 144zm0-240a95.31 95.31 0 0 0-25.31 3.79 47.85 47.85 0 0 1-66.9 66.9A95.78 95.78 0 1 0 288 160z" />
  </svg>
);

const EyeSlashIcon = (props) => (
  <svg
    viewBox="0 0 640 512"
    width="1em"
    height="1em"
    fill="currentColor"
    aria-hidden="true"
    focusable="false"
    {...props}
  >
    <path d="M320 400c-75.85 0-137.25-58.71-142.9-133.11L72.2 185.82c-13.79 17.3-26.48 35.59-36.72 55.59a32.35 32.35 0 0 0 0 29.19C89.71 376.41 197.07 448 320 448c26.91 0 52.87-4 77.89-10.46L346 397.39a144.13 144.13 0 0 1-26 2.61zm313.82 58.1l-110.55-85.44a331.25 331.25 0 0 0 81.25-102.07 32.35 32.35 0 0 0 0-29.19C550.29 135.59 442.93 64 320 64a308.15 308.15 0 0 0-147.32 37.7L45.46 3.37A16 16 0 0 0 23 6.18L3.37 31.45A16 16 0 0 0 6.18 53.9l588.36 454.73a16 16 0 0 0 22.46-2.81l19.64-25.27a16 16 0 0 0-2.82-22.45zm-183.72-142l-39.3-30.38A94.75 94.75 0 0 0 416 256a94.76 94.76 0 0 0-121.31-92.21A47.65 47.65 0 0 1 304 192a46.64 46.64 0 0 1-1.54 10l-73.61-56.89A142.31 142.31 0 0 1 320 112a143.92 143.92 0 0 1 144 144c0 21.63-5.29 41.79-13.9 60.11z" />
  </svg>
);

const OuterContainer = styled.div`
  width: 100%;
  margin: 0 auto;
  max-width: 800px;
  box-sizing: border-box;
  padding: 48px 20px 60px;
`;

const TitleHeader = styled.div`
  width: 100%;
  background-color: #195174;
  padding: 2px 10px;
  border-radius: 10px 10px 0 0;
  box-sizing: border-box;
`;

const ResetFormContainer = styled.div`
  background: rgba(255, 255, 255);
  padding: 20px;
  border-radius: 0px 0px 10px 10px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  text-align: left;
  width: 100%;
  box-sizing: border-box;
`;

const Title = styled.h3`
  color: #ffffff;
  font-size: 16px;
`;

const InstructionText = styled.p`
  font-size: 0.9rem;
  color: #195174;
  margin-bottom: 15px;
`;

const Label = styled.label`
  font-style: normal;
  font-size: 1rem;
  color: #195174;
  margin-bottom: 3px;
`;

const InputContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
`;

const TextInput = styled.input`
  width: 100%;
  padding: 10px;
  margin-bottom: 10px;
  font-size: 16px;
  border: 1px solid #195174;
  border-radius: 5px;
  padding-right: 40px; 
`;

const ToggleVisibilityButton = styled.button`
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  cursor: pointer;
  color: #195174;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  width: 32px;
  height: 32px;

  svg {
    width: 20px;
    height: 20px;
  }
`;

const primaryButtonStyles = `
  display: block;
  width: 100%;
  padding: 10px;
  margin-top: 20px;
  font-size: 16px;
  border: none;
  border-radius: 5px;
  background-color: #195174;
  color: white;
  cursor: pointer;
  font-weight: bold;

  &:hover {
    background-color: #2980b9;
  }

  &:disabled {
    background-color: #cccccc;
    cursor: not-allowed;
  }
`;

const Button = styled.button`
  ${primaryButtonStyles}
`;

export const SecondaryButton = styled.button`
  ${primaryButtonStyles}
  margin-top: 0;
  background-color: transparent;
  color: #195174;
  border: 2px solid #195174;

  &:hover {
    background-color: #195174;
    color: #fff;
  }
`;

const ErrorMessage = styled.div`
  background-color: #f8d7da;
  padding: 10px;
  margin-bottom: 10px;
`;

const SuccessMessage = styled.div`
  background-color: #d4edda;
  padding: 10px;
  margin-bottom: 10px;
`;


const CriteriaList = styled.div`
  margin-top: 12px;
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

const CriteriaItem = styled.p`
  margin: 0;
  font-size: 0.9rem;
  color: ${({ $met }) => ($met ? "green" : "#c53030")};
`;

const ResetPassword = () => {
  const [searchParams] = useSearchParams();
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState("");
  const [success, setSuccess] = useState(false);
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [confirmPasswordVisible, setConfirmPasswordVisible] = useState(false);
  const [hasInteracted, setHasInteracted] = useState(false);
  const [confirmTouched, setConfirmTouched] = useState(false);
  const [isPasswordTooLong, setIsPasswordTooLong] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  // Password validation states
  const [passLength, setPassLength] = useState(false);
  const [hasLower, setHasLower] = useState(false);
  const [hasUpper, setHasUpper] = useState(false);
  const [hasNumber, setHasNumber] = useState(false);
  const [hasSpecial, setHasSpecial] = useState(false);
  const MAX_PASSWORD_LENGTH = 128;
  const passwordsMatch = password === confirmPassword;

  const code = location.pathname.split("/password/reset/")[1]?.split("?")[0];
  let email = searchParams.get("email");
  email = email?.replace(/ /g, "+"); 

  const handlePasswordChange = (value) => {
    setPassword(value);
    setMessage("");
    setHasInteracted(true);
    setIsPasswordTooLong(value.length > MAX_PASSWORD_LENGTH);
    setPassLength(value.length >= 8);
    setHasLower(/[a-z]/.test(value));
    setHasUpper(/[A-Z]/.test(value));
    setHasNumber(/\d/.test(value));
    setHasSpecial(/[!@#$%^&*(),.?":{}|<>]/.test(value));
    if (confirmTouched) {
      setConfirmTouched(false);
    }
  };

  const handleResetPassword = async () => {
    if (isPasswordTooLong) {
      setMessage("Password cannot exceed 128 characters.");
      return;
    }

    if (password !== confirmPassword) {
      setMessage("Passwords do not match.");
      return;
    }

    try {
      let pixelToken;
      try {
        pixelToken = await fetchFreshPixelToken();
      } catch (error) {
        console.warn("Unable to obtain pixel token for password reset.", error);
        setMessage("Unable to reset password at this time. Please refresh and try again.");
        return;
      }

      if (!pixelToken) {
        setMessage("Unable to reset password at this time. Please refresh and try again.");
        return;
      }

      const response = await API.forgetPasswordReset(
        email,
        code,
        password,
        confirmPassword,
        pixelToken
      );

      if (response.status === "Success") {
        setSuccess(true);
        setMessage("Password reset successfully. You can now log in.");
        setTimeout(() => navigate("/user/login"), 1200);
      } else {
        setMessage(response.message);
      }
    } catch (error) {
      console.error("Error resetting password:", error);
      setMessage("An error occurred. Please try again.");
    }
  };

  const criteria = [
    { label: "At least 8 characters", met: passLength },
    { label: "At least 1 lowercase letter", met: hasLower },
    { label: "At least 1 uppercase letter", met: hasUpper },
    { label: "At least 1 number", met: hasNumber },
    { label: "At least 1 special character", met: hasSpecial },
  ];

  const canSubmit =
    passLength &&
    hasLower &&
    hasUpper &&
    hasNumber &&
    hasSpecial &&
    passwordsMatch &&
    !isPasswordTooLong;
  const matchMessageColor = passwordsMatch ? "#2f855a" : "#c53030";
  const matchMessage = passwordsMatch ? "Passwords match." : "Passwords must match.";

  return (
    <OuterContainer>
      <TitleHeader>
        <Title>Reset Password</Title>
      </TitleHeader>
      <ResetFormContainer>
        {success ? (
          <SuccessMessage>{message}</SuccessMessage>
        ) : (
          <>
            {message && <ErrorMessage>{message}</ErrorMessage>}
            <InstructionText>
              Please create a secure password with at least 8 characters,
              including one uppercase letter, one lowercase letter, one number,
              and one special character.
            </InstructionText>

            <Label>New Password</Label>
            <InputContainer>
              <TextInput
                type={passwordVisible ? "text" : "password"}
                placeholder="Enter your new password"
                value={password}
                onChange={(e) => handlePasswordChange(e.target.value)}
                onBlur={() => setHasInteracted(true)}
              />
              <ToggleVisibilityButton
                type="button"
                onClick={() => setPasswordVisible(!passwordVisible)}
                aria-label={passwordVisible ? "Hide new password" : "Show new password"}
              >
                {passwordVisible ? <EyeSlashIcon /> : <EyeIcon />}
              </ToggleVisibilityButton>
            </InputContainer>

            <Label>Confirm Password</Label>
            <InputContainer>
              <TextInput
                type={confirmPasswordVisible ? "text" : "password"}
                placeholder="Confirm your password"
                value={confirmPassword}
                onChange={(e) => {
                  setConfirmPassword(e.target.value);
                  setMessage("");
                  setHasInteracted(true);
                }}
                onBlur={() => setConfirmTouched(true)}
              />
              <ToggleVisibilityButton
                type="button"
                onClick={() => setConfirmPasswordVisible(!confirmPasswordVisible)}
                aria-label={confirmPasswordVisible ? "Hide password confirmation" : "Show password confirmation"}
              >
                {confirmPasswordVisible ? <EyeSlashIcon /> : <EyeIcon />}
              </ToggleVisibilityButton>
            </InputContainer>

            {hasInteracted && (
              <CriteriaList>
                {criteria.map((criterion) => (
                  <CriteriaItem key={criterion.label} $met={criterion.met}>
                    {criterion.label}
                  </CriteriaItem>
                ))}
              </CriteriaList>
            )}

            {confirmTouched && confirmPassword && (
              <InstructionText style={{ color: matchMessageColor }}>
                {matchMessage}
              </InstructionText>
            )}

            {isPasswordTooLong && (
              <InstructionText style={{ color: "#c53030" }}>
                Password cannot exceed {MAX_PASSWORD_LENGTH} characters.
              </InstructionText>
            )}

            <Button
              onClick={handleResetPassword}
              disabled={!canSubmit}
            >
              Reset Password
            </Button>
          </>
        )}
      </ResetFormContainer>
    </OuterContainer>
  );
};

export default ResetPassword;
